import { render, staticRenderFns } from "./RevenueSumReportSums.vue?vue&type=template&id=15136124&scoped=true"
import script from "./RevenueSumReportSums.vue?vue&type=script&lang=js"
export * from "./RevenueSumReportSums.vue?vue&type=script&lang=js"
import style0 from "./RevenueSumReportSums.vue?vue&type=style&index=0&id=15136124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15136124",
  null
  
)

export default component.exports